import { NgModule } from '@angular/core';
import { translationChunksConfig } from '@spartacus/assets';
import { AuthConfig, provideConfig } from '@spartacus/core';
import { MediaConfig, defaultCmsContentProviders, layoutConfig, mediaConfig } from '@spartacus/storefront';
import { environment } from 'src/environments/environment';
import { knBrStorefrontConfig } from '../common/kn-br-storefront.config';

@NgModule({
  providers: [
    provideConfig(layoutConfig),
    provideConfig(mediaConfig),
    provideConfig(<MediaConfig>{
      missingImage: 'assets/images/Product_300x300.png',
    }),
    provideConfig(knBrStorefrontConfig),
    ...defaultCmsContentProviders,
    provideConfig({
      backend: {
        occ: {
          baseUrl: environment.BASEURL,
          prefix: environment.PREFIX,
        },
      },
      context: {
        currency: ['USD', 'CAD'],
        language: ['en','fr_CA'],
        baseSite: environment.BASE_SITE,
      },
      features: {
        level: '*',
        // Knack's header has its own custom mobile layout for SiteContext/SiteLinks/SiteLogin/NavigationBar,
        // so this Spartacus default (hides those slots below the lg breakpoint) is disabled.
        unifiedDefaultHeaderSlotsAcrossBreakpoints: false,
      },
      pwa: {
        enabled: true,
        addToHomeScreen: true,
      },
      i18n: {
        chunks: translationChunksConfig,
      },
      routing: {
        protected: true,
        routes: {
          privacyPolicy: {
            paths: ['privacy-policy'],
            protected: false,
          },
          termsOfUse: {
            paths: ['terms-of-use'],
            protected: false,
          },
          contactUs: {
            paths: ['contact-us'],
            protected: false,
          },
          customerService: {
            paths: ['customer-service'],
            protected: false,
          },
          faq: {
            paths: ['faq'],
            protected: false,
          },
          cxPreview: {
            paths: ['cx-preview'],
            protected: false,
          },
        },
      },
      smartEdit: {
        storefrontPreviewRoute: 'cx-preview',
        allowOrigin: environment.ORIGIN,
      },
    }),
  ],
})
export class SpartacusConfigurationModule { }
